import Typography from '@/common/components/base/typography/Typography';
import { Flex } from 'styled-system/jsx';
import RialAmount from '../cashComponent/RialAmount';
import WalletDetailLink from './WalletDetailLink';
import WalletWrapperCard from './WalletWrapperCard';

export default function CreditCard({
  amount,
  paymentDate,
}: {
  amount: number;
  paymentDate: string;
}) {
  return (
    <WalletWrapperCard
      wrapperProps={{
        width: '100%',
        padding: '12px',
        border: '1px solid {colors.gray-3}',
        bgColor: 'white',
      }}
    >
      <Flex flexDirection={'column'} gap={16}>
        <Flex
          height={32}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <RialAmount amount={amount} />
          <WalletDetailLink text="جزئیات واریزی" />
        </Flex>
        <Flex alignItems={'center'} gap={8}>
          <Typography color={'black-2'}>تاریخ واریز:</Typography>
          <Typography color={'black'}>{paymentDate}</Typography>
        </Flex>
      </Flex>
    </WalletWrapperCard>
  );
}
